import React from "react";
import headerIcon from "../../../../assets/icons/overall-performance-icon.svg";
import headerBackground from "../../../../assets/images/report_overall_backgroud.svg";

// Import your StatusLevel type if you want stricter typing:
import { StatusLevel } from "../../types";

interface OverallPerformanceCardProps {
  score: number | string;
  maxScore: number | string;
  ratingLevel: StatusLevel; // or `string` if you prefer
  strengths: string;
  improvements: string;
}

const OverallPerformanceCard: React.FC<OverallPerformanceCardProps> = ({
  score,
  maxScore,
  ratingLevel,
  strengths,
  improvements,
}) => {
  // 1) Ensure we have a numeric form for formatting:
  const numericScore = typeof score === "string" ? parseFloat(score) : score;
  // 2) Format to two decimals (e.g., 3.23)
  const formattedScore = numericScore.toFixed(2);

  // 3) Split into integer and decimal parts
  const [intPart, decimalPart] = formattedScore.split(".");

  return (
    <div
      className="relative bg-white rounded-lg shadow-sm w-full h-full overflow-hidden"
      style={{
        // background: "linear-gradient(92deg, #FFF 3.99%, #D9E4FF 144.64%)",
        border: "1px solid #E6E8EB",
      }}
    >
      {/* Background Image behind everything (optional) */}

      {/* Foreground Content */}
      <div className="relative z-20 flex flex-col w-full h-full">
        {/* 1) Icon and Title */}
        <div className="bg-[#F5F6F7] p-4 rounded-t-lg">
          <div className="flex items-start gap-3">
            {/* Icon on the left */}
            <img
              src={headerIcon}
              alt="Header Icon"
              className="w-8 h-8"
              style={{
                filter:
                  "invert(27%) sepia(93%) saturate(1862%) hue-rotate(227deg) brightness(89%) contrast(98%)",
              }}
            />

            {/* Title */}
            <h2 className="text-xl font-semibold text-gray-900">
              Overall Performance
            </h2>
          </div>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          {/* Rating Level */}
          <p className="text-sm mb-4 text-[#474A52]">{ratingLevel}</p>

          {/* 2) Score - Commented out as requested */}
          {/* <div className="flex items-baseline mb-4">
            <span className="text-6xl font-bold text-[var(--color-primary)]">
              {intPart}
            </span>

            <span className="text-2xl text-[#474A52] ml-2">/ {maxScore}</span>
          </div> */}

          {/* 3) Divider */}
          <div className="border-t border-C8C8CA-700 mb-4 mt-4" />

          {/* 4) Strengths Section */}
          <div className="mb-4">
            <div className="inline-block px-3 py-1 bg-[#EBF0FF] rounded-[13px] mb-2">
              <span className="text-sm font-medium text-[#1B58F4]">
                Strengths
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">{strengths}</p>
          </div>

          {/* 5) Improvements Section */}
          <div>
            <div className="inline-block px-3 py-1 bg-[#FFEADE] rounded-[13px] mb-2">
              <span className="text-sm font-medium text-[#FB5D01]">
                Improvements
              </span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              {improvements}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallPerformanceCard;
